/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */

import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { postRecentSearchAPI } from '@/api/postRecentSearch';
import { getIpfsHash } from '@/hooks/urlParamsAbstract';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getIPFSAsset } from '@/utils/getIPFSAssets';
import { getIPFSDirectoryContent } from '@/utils/getIPFSDirectoryContent';
import {
  IFilePreviewURL,
  IFileResponse,
} from 'interfaces/IpfsHashList/FileListing';

import ApiFailurePage from '../ErrorPage/ApiFailurePage';
import FileSideTab from '../PreviewScreen/FileSideTab';
import FileListing from './FileListing';

const IpfsHashList = () => {
  const [allFile, setAllFile] = useState<Array<IFileResponse>>();
  const [ipfsHash, setIpfsHash] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filePathName, setFilePathName] = useState('');
  const [nestedFolder, setNestedFolder] = useState([]);
  const [filePreviewURL, setFilePreviewURL] = useState<IFilePreviewURL>({
    type: '',
    url: '',
  });
  const [fileErrorMessage, setFileErrorMessage] = useState('');
  const [changeFilePath, setChangeFilePath] = useState(false);
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const router = useRouter();
  const getFIlePreviewLink = async (ipfsPath: any) => {
    const image: any = await getIPFSAsset({
      ipfsHash: ipfsPath,
      options: { responseType: 'blob' },
    });
    const imageURL = URL.createObjectURL(image?.data);
    setFilePreviewURL({ url: imageURL, type: image.data.type });
    setChangeFilePath(true);
    setFilePathName(ipfsPath);
  };

  const postRecentSearches = async ({
    name,
    IPFSHash,
    previewURL,
    prefferedGateway,
  }: {
    name: string;
    IPFSHash: string;
    previewURL: string;
    prefferedGateway: string;
  }) => {
    try {
      postRecentSearchAPI({
        name,
        IPFSHash,
        previewURL,
        prefferedGateway,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const getFiles = (Ipfspath: string) => {
    if (Ipfspath) {
      setIsLoading(true);
      setAllFile([]);
      const data = getIPFSDirectoryContent(Ipfspath);
      data
        .then((item) => {
          if (item.links.length > 1) {
            setAllFile(item.links);
          }
          if (item.links.length === 1) {
            getFIlePreviewLink(item.links[0].path);
            setAllFile(item.links);
          }
          setIsLoading(false);
          postRecentSearches({
            name: item.links[0].name || Ipfspath,
            IPFSHash: Ipfspath,
            previewURL: filePreviewURL.url || window.location.href,
            prefferedGateway: item.gatewayURL,
          });
        })
        .catch((err) => {
          setFileErrorMessage(err.message);
          setIsLoading(false);
        });

      setFilePathName(Ipfspath);
    }
  };
  const goBackToFile = (index: number) => {
    if (index === -1) {
      setFilePathName(ipfsHash);
    } else {
      setFilePathName(ipfsHash);
      for (let i = 0; i <= index; i += 1) {
        setFilePathName((prev) => {
          return `${prev}/${nestedFolder[i]}`;
        });
      }
    }
    setFilePreviewURL({
      type: '',
      url: '',
    });
    setFileErrorMessage('');
  };
  useEffect(() => {
    const hash = getIpfsHash(router);
    setIpfsHash(hash);
    if (hash) {
      getFiles(hash);
    }
  }, [router]);
  useEffect(() => {
    const myFileList = filePathName.split('/');
    myFileList.shift();
    setNestedFolder(myFileList);
    if (!changeFilePath) getFiles(filePathName);
    setChangeFilePath(false);
  }, [filePathName]);

  if (fileErrorMessage && nestedFolder.length === 0) {
    return <ApiFailurePage message={fileErrorMessage} />;
  }

  return (
    <>
      {isMediaMax1025px ? (
        <div className="w-full h-full">
          <FileSideTab
            isIpfsPreview
            isActive={'File'}
            allFile={allFile}
            getIpfsFiles={getFiles}
            getFIlePreviewLink={getFIlePreviewLink}
            goBackToFile={goBackToFile}
            nestedFolder={nestedFolder}
            filePreviewURL={filePreviewURL}
            isIpfsPreviewLoading={isLoading}
            ipfsPreviewHash={ipfsHash}
            fileErrorMessage={fileErrorMessage}
          />
        </div>
      ) : (
        <div className="w-[100%] justify-center flex">
          <div className="w-[100%] grid grid-cols-4  h-full max-w-[1800px]">
            <div className="  col-span-3 mr-4">
              <section className="h-[76vh]  flex-col  relative w-full bg-white rounded-[8px] box-border">
                <FileListing
                  file={allFile}
                  getFiles={getFiles}
                  getFIlePreviewLink={getFIlePreviewLink}
                  goBackToFile={goBackToFile}
                  nestedFolder={nestedFolder}
                  filePreviewURL={filePreviewURL}
                  isLoading={isLoading}
                  fileErrorMessage={fileErrorMessage}
                />
              </section>
            </div>

            <div className="flex justify-center">
              <FileSideTab
                isIpfsPreview
                isActive="About"
                allFile={allFile}
                getIpfsFiles={getFiles}
                getFIlePreviewLink={getFIlePreviewLink}
                goBackToFile={goBackToFile}
                nestedFolder={nestedFolder}
                filePreviewURL={filePreviewURL}
                isIpfsPreviewLoading={isLoading}
                ipfsPreviewHash={ipfsHash}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default IpfsHashList;
